import React, { useEffect, useState } from "react";
import { Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { navigate } from "gatsby";
import { use2FASetting } from "../../hooks/2fa-setting.hooks";
import "./two-fa-snackbar.scss";

const TwoFASnackbar = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  const { data: mfaSetting, isSuccess } = use2FASetting();
  const handleClose = () => {
    setIsClosing(true);
    // Wait for animation to finish before unmounting
    setTimeout(() => {
      setIsVisible(false);
      setIsClosing(false);
    }, 300);
  };

  useEffect(() => {
    if (isSuccess) {
      if (!mfaSetting) {
        setIsVisible(true);
      } else if (isVisible) {
        handleClose();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, mfaSetting]);

  const handleSetupClick = () => {
    navigate("/account/");
    handleClose();
  };

  if (!isVisible) return null;

  return (
    <Box
      className={`two-fa-snackbar ${isClosing ? "two-fa-snackbar--closing" : ""}`}
    >
      <div className="two-fa-snackbar__content">
        <div className="two-fa-snackbar__icon">
          <WarningAmberRoundedIcon />
        </div>
        <p className="two-fa-snackbar__message">
          Hey! It looks like you haven&apos;t turned on 2FA yet. For your
          account&apos;s safety, go ahead and enable it now!
        </p>
      </div>
      <div className="two-fa-snackbar__actions">
        <button
          className="two-fa-snackbar__button"
          onClick={handleSetupClick}
          type="button"
        >
          Set 2FA Now
        </button>
        <IconButton
          size="small"
          onClick={handleClose}
          className="two-fa-snackbar__close"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>
    </Box>
  );
};

export default TwoFASnackbar;
